export const areaObj = {
  '境内': 'Domestic',
  '境外': 'Foreign'
}
export const IdObj = {
  '法人': 'Legal person',
  '自然人': 'Natural person'
}
export const statusObj = {
  '正常': 'Active',
  '已作废': 'Void',
  '重新开具': 'Reissued',
}
export const statusObj2 = {
  '正常': 'Active',
  '异常': 'Not Active',
}

export const levelObj = [
  {
    label: '志工',
    en_label: 'Volunteer'
  },
  {
    label: '見習',
    en_label: 'Apprentice Commissioner'
  },
  {
    label: '培訓',
    en_label: 'Training Commissioner'
  },
  {
    label: '慈誠',
    en_label: 'Faith Corps Member'
  },
  {
    label: '委員',
    en_label: 'Commissioner'
  },
]

export const monthstyle = `
@page {
}
.print_gap{page-break-before: always;}
@media print{
.monthInvoice {
  min-height: 400px;
  padding: 10px;
  width:100%;
}
.monthInvoice h3 {
  width: 100%;
  text-align: center;
}
.monthInvoice .month {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding-bottom: 20px;
  border-bottom: 2px solid #000;
  margin-bottom: 10px;
}
.monthInvoice .month2 {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.monthInvoice .monTitle {
  margin-bottom: 20px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.monthInvoice .monTitle table {
  width: 72%;
}
.monthInvoice .monTitle table th {
  text-align: center;
}
.monthInvoice .monTitle2 {
  width: 100%;
}
.monthInvoice .monTitle2 table {
  width: 100%;
  page-break-inside: avoid;
}
.monthInvoice .monTitle2 table th {
  text-align: center;
}
.monthInvoice .areaItem {
  margin-bottom: 20px;
  page-break-inside: avoid;
}
.monthInvoice .areaItem .areaTotal {
  display: flex;
  padding-left: 65px;
  width: 55%;
  justify-content: flex-end;
}
.monthInvoice .areaItem .areaTotal .count {
  margin-left: 10px;
  border-top: 1px solid #000;
  border-bottom: 1px solid #000;
  width: 100px;
  text-align: right;
  display: flex;
  justify-content: flex-end;
}
.monthInvoice .areaItem .areaTotal .count span {
  flex: 1;
  text-align: right;
}
.monthInvoice .areaItem .areaTotal .count.style {
  width: 77%;
  min-width: 77%;
}
.monthInvoice .areaItem .areaTotal.style {
  width: 100%;
}
.monthInvoice .subItem {
  padding-left: 65px;
  width: 55%;
  display: flex;
  justify-content: space-between;
}
.monthInvoice .subItem .monArr {
  display: flex;
  width: 77%;
  min-width: 77%;
}
.monthInvoice .subItem .monArr span {
  flex: 1;
  text-align: right;
}
.monthInvoice .subItem.style {
  width: 100%;
}
.monthInvoice .total {
  display: flex;
  justify-content: space-between;
  width: 55%;
}
.monthInvoice .total.style {
  width: 100%;
}

.monthInvoice {
  width: 100% ;
  min-height: 400px;
  padding: 10px;
}
.monthInvoice h3 {
  width: 100%;
  text-align: center;
}
.monthInvoice .month {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding-bottom: 20px;
  border-bottom: 2px solid #000;
  margin-bottom: 10px;
}
.monthInvoice .monTitle {
  margin-bottom: 20px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.monthInvoice .monTitle table {
  width: 72%;
}
.monthInvoice .monTitle table th {
  text-align: center;
}
.monthInvoice .areaItem {
  margin-bottom: 20px;
  page-break-inside: avoid;
}
.monthInvoice .areaItem .areaTotal {
  display: flex;
  padding-left: 65px;
  width: 55%;
  justify-content: flex-end;
}
.monthInvoice .areaItem .areaTotal .count {
  margin-left: 10px;
  border-top: 1px solid #000;
  border-bottom: 1px solid #000;
  width: 100px;
  text-align: right;
  display: flex;
  justify-content: flex-end;
}
.monthInvoice .areaItem .areaTotal .count span {
  flex: 1;
  text-align: right;
}
.monthInvoice .areaItem .areaTotal .count.style {
  width: 77%;
  min-width: 77%;
}
.monthInvoice .areaItem .areaTotal.style {
  width: 100%;
}
.monthInvoice .subItem {
  padding-left: 65px;
  width: 55%;
  display: flex;
  justify-content: space-between;
}
.monthInvoice .subItem .monArr {
  display: flex;
  width: 77%;
  min-width: 77%;
}
.monthInvoice .subItem .monArr span {
  flex: 1;
  text-align: right;
}
.monthInvoice .subItem.style {
  width: 100%;
}
.monthInvoice .total {
  display: flex;
  justify-content: space-between;
  width: 55%;
}
.monthInvoice .total.style {
  width: 100%;
}

}
`